import { KILOGRAM_TO_POUND } from "@einride/ui"
import { UnitSystem, useUserPreferences } from "components/UserPreferences/UserPreferencesContext"

interface WeightProps {
  kilograms: number
}

export const Weight = ({ kilograms }: WeightProps): React.JSX.Element => {
  const { locale, unitSystem } = useUserPreferences()
  return <>{formatWeight(locale, unitSystem, kilograms)}</>
}

export const WeightUnit = (): React.JSX.Element => {
  const { unitSystem } = useUserPreferences()
  return <>{getWeightUnit(unitSystem)}</>
}

function formatWeight(locale: string, unitSystem: UnitSystem, kilograms: number): string {
  if (unitSystem === UnitSystem.Imperial) {
    return new Intl.NumberFormat(locale, {
      unit: "pound",
      style: "unit",
      unitDisplay: "short",
      maximumFractionDigits: 2,
    }).format(kilograms)
  }
  return new Intl.NumberFormat(locale, {
    unit: "kilogram",
    style: "unit",
    unitDisplay: "short",
    maximumFractionDigits: 2,
  }).format(kilograms)
}

export function getWeightUnit(unitSystem: UnitSystem): string {
  if (unitSystem === UnitSystem.Imperial) {
    return "lbs"
  }
  return "kg"
}

export const kilogramsToPounds = (kilograms: number): number => {
  return kilograms * KILOGRAM_TO_POUND
}
